import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getFciLoanDetail } from 'services'
import { setLoanNumber } from 'utils/setLoanNumber'

import {
  fciBorrowerInfoSection,
  fciDateInfoSection,
  fciLoanInfoSection,
  fciPaymentInfoSection,
  fciValueTypeMap,
  renderFCIvalue,
} from '../constants'

export const FciLoanDetail = ({ servicerNo = 0 }: { servicerNo?: number }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})

  const initData = async () => {
    setLoading(true)
    const res = await getFciLoanDetail(servicerNo)
    setData(res)
    setLoading(false)
  }

  useEffect(() => {
    setLoanNumber()
    initData()
  }, [])

  const renderSection = (title: string, sectionValues: Record<string, string>) => {
    return (
      <div className="shadow rounded border mb-4 text-[15px]">
        <div className="bg-gray-200 round-t py-1 px-4">{title}</div>
        <div className="p-2 grid grid-cols-2 gap-1">
          {Object.keys(sectionValues).map((key: string) => {
            return (
              <>
                <div className="col-span-1">{sectionValues[key]}</div>
                <div className="col-span-1 text-right text-shade-blue">
                  {renderFCIvalue(data[key], fciValueTypeMap[key])}
                </div>
              </>
            )
          })}
        </div>
      </div>
    )
  }
  return (
    <div className="fci-loan-detail-container px-2">
      <div className="max-w-screen-2xl m-auto">
        <div className="relative bg-white mt-6">
          <LayoutLoading show={loading} />
          <div className="grid md:grid-cols-12 gap-5">
            <div className="md:col-span-6">
              {renderSection('Loan Information', fciLoanInfoSection)}
              {renderSection('Date Information', fciDateInfoSection)}
            </div>
            <div className="md:col-span-6">
              {renderSection('Payment Information', fciPaymentInfoSection)}
              {renderSection('Borrower Information', fciBorrowerInfoSection)}
              <div className="shadow rounded border mb-4">
                <div className="bg-gray-200 round-t py-1 px-4">Co-Borrower List</div>
                <div className="p-2 text-shade-blue">{`${data.coBorrower}`}</div>
              </div>
              <div className="shadow rounded border mb-4">
                <div className="bg-gray-200 round-t py-1 px-4">Property List</div>
                <div className="p-2 text-shade-blue">
                  {`${data.propertyStreet}, ${data.propertyCity} ${data.propertyState} ${data.propertyZip}`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
